<template>
    <div class="standort-detail-wrapper" ref="detailStandort" v-if="selectedStandort">
        <div class="standort-detail">
            <div class="standort-detail-close" @click="closeStandort">
                <img :src="getImage('x.svg')" alt="close">
            </div>
            <div class="standort-detail-left">
                <div class="standort-detail-header">
                    <span class="standort-detail-medau">Medau</span>{{ field }}<br/>
                    <span id="standort-location">{{ selectedStandort.attributes.Ort }}</span>
                </div>
                <a class="standort-detail-phone" :href="'tel:'+selectedStandort.attributes.Telefon">
                    {{ selectedStandort.attributes.Telefon }}
                </a>
                <div class="standort-detail-contact">
                    <div class="standort-detail-contact-management">
                        <div class="standort-detail-subheading">Fachliche Leitung:</div>
                        <div class="standort-detail-contact-management-image"
                             :style="'background-image: url('+this.config.imageBaseUrl
                             +selectedStandort.attributes.Leitung?.data?.attributes?.BildURL+');'"/>
                        <div class="standort-detail-text">
                            {{ selectedStandort.attributes.Leitung?.data?.attributes?.Name }}
                        </div>
                    </div>
                    <div class="standort-detail-contact-mail">
                        <div class="standort-detail-subheading">E-Mail:</div>
                        <a class="standort-detail-text" :href="'mailto:'+selectedStandort.attributes.EMail">
                            {{ selectedStandort.attributes.EMail }}
                        </a>
                    </div>
                    <div class="standort-detail-contact-address">
                        <div class="standort-detail-subheading">Adresse:</div>
                        <div class="standort-detail-text" v-html="getAddress"/>
                    </div>
                </div>
            </div>
            <div class="standort-detail-right">
                <div class="standort-detail-images">
                    <template v-if="selectedStandort.attributes.Bilder.data"
                              v-for="bild in selectedStandort.attributes.Bilder.data">
                        <div class="standort-detail-image"
                             :style="'background-image: url('+this.config.imageBaseUrl
                             +bild.attributes.formats.medium.url+')'"/>
                    </template>
                </div>
                <div class="standort-detail-opening-hours">
                    <div class="standort-detail-subheading">Öffnungszeiten:</div>
                    <div class="standort-detail-opening-hours-text">
                        <template v-if="selectedStandort.attributes.Oeffnungszeiten"
                                  v-for="zeit in selectedStandort.attributes.Oeffnungszeiten">
                            <div class="standort-detail-opening-hours-line">
                                <div class="standort-detail-opening-hours-day">{{ zeit.Tag }}</div>
                                <div class="standort-detail-opening-hours-time">
                                    {{ formatTime(zeit.Beginn) }} - {{ formatTime(zeit.Ende) }} Uhr
                                </div>
                            </div>
                        </template>
                        <template v-if="selectedStandort.attributes.OeffnungszeitenFreitext">
                            <div class="standort-detail-opening-hours-rich"
                                 v-html="selectedStandort.attributes.OeffnungszeitenFreitext"/>
                        </template>
                    </div>
                </div>
                <div class="standort-detail-contact-form">
                    <form @submit.prevent="sendContactMail()">
                        <div class="standort-detail-contact-form-line">
                            <div class="standort-detail-contact-form-label">
                                <label for="standort-name">Name*:</label>
                            </div>
                            <div class="standort-detail-contact-form-input">
                                <input type="text" name="standort-name" id="standort-name"
                                       placeholder="Name">
                                <span class="form-error" v-if="mailFormErrorName">Bitte geben Sie Ihren Namen an!</span>
                            </div>
                        </div>
                        <div class="standort-detail-contact-form-line">
                            <div class="standort-detail-contact-form-label">
                                <label for="standort-phone">Telefonnummer:</label>
                            </div>
                            <div class="standort-detail-contact-form-input">
                                <input type="text" name="standort-phone" id="standort-phone"
                                       placeholder="Telefonnummer">
                            </div>
                        </div>
                        <div class="standort-detail-contact-form-line">
                            <div class="standort-detail-contact-form-label">
                                <label for="standort-mail">E-Mail*:</label>
                            </div>
                            <div class="standort-detail-contact-form-input">
                                <input type="text" name="standort-mail" id="standort-mail"
                                       placeholder="E-Mail">
                                <span class="form-error" v-if="mailFormErrorMail">
                                    Bitte geben Sie Ihre E-Mail-Adresse an!</span>
                            </div>
                        </div>
                        <div class="standort-detail-contact-form-line">
                            <div class="standort-detail-contact-form-label">
                                <label for="standort-message">Nachricht*:</label>
                            </div>
                            <div class="standort-detail-contact-form-input">
                                <textarea name="standort-message" id="standort-message"
                                          placeholder="Nachricht"></textarea>
                                <span class="form-error"
                                      v-if="mailFormErrorMessage">Bitte geben Sie eine Nachricht ein!</span>
                            </div>
                        </div>
                        <div class="standort-detail-contact-form-line">
                            <div class="standort-detail-contact-form-label">
                                <label for="standort-privacy">Datenschutz*:</label>
                            </div>
                            <div class="standort-detail-contact-form-input">
                                <label>
                                    <input type="checkbox" name="standort-privacy" id="standort-privacy">
                                    Ja, ich bin einverstanden, dass meine personenbezogenen Daten
                                    elektronisch erhoben und gespeichert werden. Meine Daten werden nur zum
                                    Zweck der Beantwortung und Bearbeitung meiner Bewerbung verwendet. Die
                                    Datenschutzhinweise habe ich zur Kenntnis genommen.*
                                </label>
                                <div class="form-error" v-if="mailFormErrorPrivacy">Bitte geben Sie Ihr
                                    Datenschutz-Einverständnis!
                                </div>
                            </div>
                        </div>
                        <div class="standort-detail-contact-form-line">
                            <div class="standort-detail-contact-form-label">
                            </div>
                            <div class="standort-detail-contact-form-input">
                                <button>Senden</button>
                                <div class="mail-success" style="margin-top: 30px;"
                                     v-if="mailSuccess">Die Nachricht wurde erfolgreich verschickt!
                                </div>
                                <div class="mail-success" v-if="mailLoading">
                                    <LoadingSpinner/>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="standort-detail-images-mobile">
                <template v-if="selectedStandort.attributes.Bilder.data"
                          v-for="bild in selectedStandort.attributes.Bilder.data">
                    <div class="standort-detail-image-mobile-wrapper">
                        <div class="standort-detail-image-mobile"
                             :style="'background-image: url('+this.config.imageBaseUrl
                             +bild.attributes.formats.medium.url+')'"/>
                    </div>
                </template>
            </div>
        </div>
    </div>
    <div class="standort-container">
        <template v-for="standort in standorte" v-if="standorte">
            <div :class="'standort '+getActiveClass(standort)" @click="selectStandort(standort)">
                <div class="standort-heading-wrapper">
                    <div class="standort-field"><span>Medau</span>{{ field }}</div>
                    <div class="standort-location">{{ standort.attributes.Ort }}</div>
                </div>
                <div class="standort-phone">{{ standort.attributes.Telefon }}</div>
            </div>
        </template>
        <template v-else>
            <i v-if="standorte===false">
                Leider konnten keine Standorte geladen werden. Bitte versuchen Sie es erneut.
            </i>
            <div class="loading-wrapper" v-else>
                <LoadingSpinner class="standort-spinner"/>
                <p>Standorte werden geladen...</p>
            </div>
        </template>
    </div>
</template>

<script>
import LoadingSpinner from "@/components/elements/LoadingSpinner.vue";
import {nextTick} from "vue";

export default {
    data() {
        return {
            standorte: null,
            selectedStandort: null,
            autoTimeoutStandort: null,
            mailFormErrorPrivacy: false,
            mailFormErrorName: false,
            mailFormErrorMail: false,
            mailFormErrorMessage: false,
            mailLoading: false,
            mailSuccess: false,
        }
    },
    components: {
        LoadingSpinner
    },
    computed: {
        field() {
            return this.$store.state.clickedField;
        },
        getAddress() {
            return this.selectedStandort.attributes.Adresse.replaceAll("\n", "<br />");
        }
    },
    watch: {
        async selectedStandort(ignored_val, ignored_oldVal) {
            if (this.selectedStandort) {
                await nextTick();
                document.getElementById("standort-name").value = '';
                document.getElementById("standort-phone").value = '';
                document.getElementById("standort-mail").value = '';
                document.getElementById("standort-message").value = '';
                document.getElementById("standort-privacy").checked = false;
                const container = this.$refs.detailStandort;
                if (this.autoTimeoutStandort !== null) {
                    clearTimeout(this.autoTimeoutStandort);
                    this.autoTimeoutStandort = null;
                }
                if (container.classList.contains("open")) {
                    return;
                }
                container.style.height = "auto";
                const height = container.clientHeight + "px";
                container.classList.add("open");
                container.style.height = "0px"
                setTimeout(() => {
                    container.style.height = height;
                }, 0);
                this.autoTimeoutStandort = setTimeout(() => {
                    container.style.height = 'auto';
                }, 500);
            }
        },
        $route(ignored_to, ignored_from) {
            if (this.$route.query.standort) {
                for (const standort of this.standorte) {
                    if (standort.id === parseInt(this.$route.query.standort, 10)) {
                        this.selectStandort(standort);
                    }
                }
            }
        }
    },
    methods: {
        getActiveClass(standort) {
            if (this.$store.state.activeStandorte === null) {
                return '';
            }
            if (this.$store.state.activeStandorte.includes(standort.id)) {
                return 'active';
            }
        },
        loadStandorte() {
            if (this.field === null) {
                this.clearTimeout = setTimeout(() => {
                    this.standorte = null;
                }, 1000);
                return;
            }
            this.apiRequest('/locations?populate[]=Leitung&populate[]=Angebote&populate[]=Oeffnungszeiten' +
                '&populate[]=Bilder&populate[]=Personen&filters[Bereich][Titel][$eq]=' + this.field)
                .then(cnt => {
                    this.standorte = cnt.data || null;
                    if (this.$route.query.standort) {
                        for (const standort of cnt.data) {
                            if (standort.id === parseInt(this.$route.query.standort, 10)) {
                                this.selectStandort(standort);
                            }
                        }
                    }
                })
                .catch(() => this.standorte = false);
        },
        closeStandort() {
            this.$store.commit("setActivePersons", null);
            this.$store.commit("setActiveOffers", null);
            const container = this.$refs.detailStandort;
            if (this.autoTimeoutStandort !== null) {
                clearTimeout(this.autoTimeoutStandort);
                this.autoTimeoutStandort = null;
            }
            if (!container.classList.contains("open")) {
                return;
            }
            container.style.height = "auto";
            const height = container.clientHeight + "px";
            container.classList.remove("open");
            container.style.height = height;
            setTimeout(() => {
                container.style.height = '0px';
            }, 0);
            setTimeout(() => {
                this.selectedStandort = null;
            }, 500);
        },
        selectStandort(standort) {
            if (this.selectedStandort === standort) {
                this.closeStandort();
            } else {
                this.selectedStandort = standort;
                const activePersons = [];
                for (const person of standort.attributes.Personen.data) {
                    activePersons.push(person.id);
                }
                this.$store.commit("setActivePersons", activePersons);
                const activeOffers = [];
                for (const angebot of standort.attributes.Angebote.data) {
                    activeOffers.push(angebot.id);
                }
                this.$store.commit("setActiveOffers", activeOffers);
            }
        },
        formatTime(zeit) {
            let parts = zeit.split(":");
            return parts[0] + ':' + parts[1];
        },
        sendContactMail() {
            const name = document.getElementById("standort-name").value;
            const phone = document.getElementById("standort-phone").value;
            const mail = document.getElementById("standort-mail").value;
            const message = document.getElementById("standort-message").value;
            const privacy = document.getElementById("standort-privacy").checked;
            const standort = this.selectedStandort;
            this.mailFormErrorPrivacy = !privacy;
            this.mailFormErrorName = name === "";
            this.mailFormErrorMail = mail === "";
            this.mailFormErrorMessage = message === "";
            if (!privacy || name === "" || mail === "" || privacy === "") {
                return;
            }
            this.mailLoading = true;
            this.mailSuccess = false;
            this.apiRequest('/contact', 'post', {
                name: name,
                phone: phone,
                mail: mail,
                message: message,
                standort: standort.id,
            })
                .then(() => {
                    this.mailLoading = false;
                    this.mailSuccess = true;

                    document.getElementById("standort-name").value = '';
                    document.getElementById("standort-phone").value = '';
                    document.getElementById("standort-mail").value = '';
                    document.getElementById("standort-message").value = '';
                    document.getElementById("standort-privacy").checked = false;
                });
        }
    },
    mounted() {
        this.loadStandorte();
    }
}
</script>